import { useState } from "react";
import axios from "axios";
import { useGlobalContext } from "../GlobalContext";

export default function useLogin() {
  const [loading, setLoading] = useState(false);

  const {
    baseurl,
    token,
    setAccessToken,
    setAdminId,
    setAdmin,
    setIsUnauthorised,
  } = useGlobalContext();

  const login = async ({
    mobile,
    password,
    step,
    otp,
    navigate,
  }) => {
    setLoading(true);

    try {
      const payload = {
        mobile,
        password,
        step: step.toString(),
        otp: step === 2 ? otp : "",
        latitude: "0.0",
        longitude: "0.0",
      };

      const response = await axios.post(
        `${baseurl}/api/Admin/v1.0/login`,
        payload,
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      );

      if (response.data.responseCode === "00") {
        if (step === 1) {
          return { success: true, nextStep: 2 };
        }

        if (step === 2) {
          const adminData = response.data.response;

          sessionStorage.setItem("admin", JSON.stringify(adminData));

          setAccessToken(adminData.accessToken);
          setAdminId(adminData.userId);
          setAdmin(adminData);

           return { success: true, completed: true };
        }
      } else if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
        return { success: false };
      } else {
        return {
          success: false,
          message: response.data.responseMessage,
        };
      }
    } catch (error) {
      return {
        success: false,
        message: "Login failed. Please try again.",
      };
    } finally {
      setLoading(false);
    }
  };

  return { login, loading };
}
